import { Contact } from './Contact';

const DEFAULT_CONTACT_IMAGE =
	'https://images.ctfassets.net/nhlptadlwhxr/5XBDusNkUGKjJ7rJu324sR/9164ffd842fa3751ad1315125ec0b490/lindner-office.webp';

export default function ContactNew({ imageUrl = DEFAULT_CONTACT_IMAGE }: { imageUrl?: string }) {
	return (
		<section className="w-full flex flex-col lg:flex-row min-h-[640px]">
			{/* Left: white background with heading and contact info */}
			<div className="w-full lg:w-1/2 flex flex-col gap-8 lg:gap-16 px-4 py-8 lg:py-16 lg:pl-[calc(max(0px,(100vw-1280px)/2)+1rem)] xl:pl-[calc(max(0px,(100vw-1440px)/2)+1rem)] lg:pr-8 bg-white">
				<div className="flex flex-col gap-4 max-w-[600px]">
					<h1 className=" text-4xl lg:text-5xl font-bold text-primary-900 !leading-normal">
						Flexible warehousing and food storage solutions backed by industry expertise
					</h1>
					<p className=" text-lg leading-relaxed">
						From inventory management to distribution, Lindner Logistics can help
						businesses simplify complex logistics operations.
					</p>
				</div>

				<div className="flex flex-col gap-4 lg:gap-8 max-w-[600px]">
					<div className="flex flex-col gap-1">
						<span className="text-[#737373] font-semibold">Visit us</span>
						<a
							href="https://maps.app.goo.gl/wr9g8HLnobxCuJWn6"
							target="_blank"
							rel="noopener noreferrer"
							className="text-[#0161A2] font-bold text-xl lg:text-2xl flex items-center gap-2 w-fit hover:underline"
						>
							Directions to our office
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="18"
								height="18"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								aria-hidden="true"
							>
								<path d="M7 17L17 7M17 7H7M17 7v10" />
							</svg>
						</a>
					</div>

					<div className="flex flex-col gap-1">
						<span className="text-[#737373] font-semibold">Email us</span>
						<a
							href="mailto:contact@lindnerlogistics.com"
							className="text-[#0161A2] font-bold text-xl lg:text-2xl hover:underline"
						>
							contact@lindnerlogistics.com
						</a>
					</div>

					<div className="flex flex-col gap-1">
						<span className="text-[#737373] font-semibold">Call us</span>
						<a
							href="tel:414-483-3080"
							className="text-[#0161A2] font-bold text-xl lg:text-2xl hover:underline w-fit"
						>
							414-483-3080
						</a>
					</div>
				</div>
			</div>

			{/* Right: background image with floating form card */}
			<div
				className="w-full lg:w-1/2 relative flex items-center justify-center p-4 lg:p-8"
				style={{
					background: `url(${imageUrl}) center/cover no-repeat`,
				}}
			>
				<div className="w-full max-w-[520px]">
					<Contact className="bg-white rounded-lg p-4 lg:p-8" title="Contact us today." />
				</div>
			</div>
		</section>
	);
}
